import React, { useState, useRef, useEffect } from 'react';

const NotificationBell = ({ newSalesCount, newSalesData, onSyncSales, loading }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // ปิด dropdown เมื่อคลิกข้างนอก
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleBellClick = () => {
    setShowDropdown(!showDropdown);
  };

  const handleSyncClick = () => {
    onSyncSales();
    setShowDropdown(false);
  };

  return (
    <div className="position-relative" ref={dropdownRef}>
      {/* ไอคอนกระดิ่งแจ้งเตือน */}
      <button
        type="button"
        className={`btn btn-link position-relative p-2 ${newSalesCount > 0 ? 'text-warning' : 'text-muted'}`}
        onClick={handleBellClick}
        title={newSalesCount > 0 ? `มีรายการขายใหม่ ${newSalesCount} รายการ` : 'ไม่มีการแจ้งเตือน'}
        style={{ fontSize: '1.5rem', border: 'none' }}
      >
        <i className={`fas fa-bell ${newSalesCount > 0 ? 'fa-shake' : ''}`}></i>
        
        {/* Badge แสดงจำนวนการแจ้งเตือน */}
        {newSalesCount > 0 && (
          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
            {newSalesCount > 99 ? '99+' : newSalesCount}
            <span className="visually-hidden">รายการใหม่</span>
          </span>
        )}
      </button>

      {/* Dropdown แสดงรายละเอียดการแจ้งเตือน */}
      {showDropdown && (
        <div 
          className="dropdown-menu dropdown-menu-end show position-absolute"
          style={{ 
            top: '100%', 
            right: '0', 
            minWidth: '350px',
            maxHeight: '400px',
            overflowY: 'auto',
            zIndex: 1050
          }}
        >
          <div className="dropdown-header d-flex justify-content-between align-items-center">
            <h6 className="mb-0 thai-text">การแจ้งเตือน</h6>
            {newSalesCount > 0 && (
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={handleSyncClick}
                disabled={loading}
              >
                <i className="fas fa-sync-alt me-1"></i>
                <span className="thai-text">{loading ? 'กำลัง Sync...' : 'Sync ทั้งหมด'}</span>
              </button>
            )}
          </div>
          
          <div className="dropdown-divider"></div>
          
          {newSalesCount === 0 ? (
            <div className="dropdown-item-text text-center text-muted py-3">
              <i className="fas fa-check-circle me-2"></i>
              <span className="thai-text">ไม่มีการแจ้งเตือนใหม่</span>
            </div>
          ) : (
            <>
              <div className="dropdown-item-text bg-light">
                <small className="text-muted thai-text">
                  มีรายการขายใหม่ {newSalesCount} รายการรอการ sync
                </small>
              </div>
              
              {newSalesData.slice(0, 5).map((sale, index) => (
                <div key={index} className="dropdown-item">
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="flex-grow-1">
                      <div className="fw-bold thai-text">
                        <i className="fas fa-receipt me-2 text-primary"></i>
                        เลขที่การขาย: {sale.sale_number || `SL-${new Date().getFullYear().toString().slice(-2)}${String(sale.id).padStart(3, '0')}`}
                      </div>
                      <div className="text-muted small">
                        <i className="fas fa-user me-1"></i>
                        ลูกค้า: {sale.customer_name || 'ไม่ระบุ'}
                      </div>
                      <div className="text-muted small">
                        <i className="fas fa-boxes me-1"></i>
                        จำนวนสินค้า: {sale.total_items || 0} รายการ
                      </div>
                      <div className="text-muted small">
                        <i className="fas fa-calendar me-1"></i>
                        วันที่ขาย: {sale.saleDate ? new Date(sale.saleDate).toLocaleDateString('th-TH') : 'ไม่ระบุ'}
                      </div>
                      {sale.total_amount && (
                        <div className="text-muted small">
                          <i className="fas fa-money-bill-wave me-1"></i>
                          ยอดรวม: {Number(sale.total_amount).toLocaleString('th-TH', {minimumFractionDigits: 2})} บาท
                        </div>
                      )}
                    </div>
                    <div className="ms-2">
                      <span className="badge bg-warning text-dark">ใหม่</span>
                    </div>
                  </div>
                </div>
              ))}
              
              {newSalesData.length > 5 && (
                <div className="dropdown-item-text text-center">
                  <small className="text-muted thai-text">
                    และอีก {newSalesData.length - 5} รายการ...
                  </small>
                </div>
              )}
              
              <div className="dropdown-divider"></div>
              <div className="dropdown-item text-center">
                <button
                  type="button"
                  className="btn btn-warning btn-sm w-100"
                  onClick={handleSyncClick}
                  disabled={loading}
                >
                  <i className="fas fa-sync-alt me-1"></i>
                  <span className="thai-text">
                    {loading ? 'กำลัง Sync...' : `Sync รายการทั้งหมด (${newSalesCount})`}
                  </span>
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;